import { followMessagesAtBottom as n, followSuffixAtBottom as l } from "../follow-strategies.js";
function s(e) {
  return {
    messages: e.messages,
    renderMessage: e.renderMessage,
    prefix: e.prefix ?? null,
    suffix: e.suffix ?? null,
    alignment: e.alignment ?? "bottom",
    style: e.style,
    className: e.className,
    scrollerStyle: e.scrollerStyle,
    scrollerClassName: e.scrollerClassName,
    overscan: e.overscan,
    ssrCount: e.ssrCount,
    keepMountedIndexes: e.keepMountedIndexes,
    keepMountedIds: e.keepMountedIds,
    historyEndOffset: e.historyEndOffset ?? 10,
    onHistoryEndReached: e.onHistoryEndReached ?? (() => {
    }),
    onScroll: e.onScroll ?? (() => {
    }),
    onScrollEnd: e.onScrollEnd ?? (() => {
    }),
    onWheel: e.onWheel ?? (() => {
    }),
    onKeyDown: e.onKeyDown ?? (() => {
    }),
    onOlderMessages: e.onOlderMessages ?? (() => {
    }),
    onNewerMessages: e.onNewerMessages ?? n(),
    onAtTop: e.onAtTop ?? (() => {
    }),
    onAtBottom: e.onAtBottom ?? (() => {
    }),
    onPrefixDisplay: e.onPrefixDisplay ?? (() => {
    }),
    onSuffixDisplay: e.onSuffixDisplay ?? l()
  };
}
export {
  s as useProps
};
